import { render } from "./Collections.vue?vue&type=template&id=fa60114e&scoped=true"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=fa60114e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fa60114e"

export default script